import React from 'react'
import images from '../../app/utlis/image'

const CRMDevPage = () => {
    return (
        <div>
            <div className='bg-eCommerce-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col justify-center items-center px-[10%] pb-8 gap-6 pt-52'>
                        <img src={images.ENTERPRISEHOMEIMAGE} className='z-10 w-[60%]' />
                        <div className='text-white flex flex-col gap-2 relative text-center justify-center items-center'>
                            <div className='font-bold text-6xl mb-2'>CRM software</div>
                            <div className='font-normal text-2xl'>Strengthen customer relationships and streamline sales with a tailored CRM system from
                                SATTVA TECH. Our adaptable software enhances interactions & growth, addressing
                                your specific needs from lead management to post-sale assistance.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>

            </div>
        </div>
    )
}

export default CRMDevPage
